/** Owner analytics identity never enables unpublished UI in the consumer app. */
export function businessPreviewAllowed(adminPreview: boolean, verifiedOwner: boolean): boolean {
  return adminPreview && verifiedOwner;
}
